<template>
    <div class="dateTimePicker-container">
         <div class="global_popup_header">{{$t('content.books.timingOn')}}<i @click="$store.commit('windowHandle')"></i></div>
        <div class="global_popup_body">
            <p>{{$t('content.books.ShelfTime')}}：</p>
            <div class="dateTimePicker-content">
                <el-date-picker class="date-time-picker" type="datetime" v-model="dateTime" :placeholder="$t('placeholder.dateTime')">
                </el-date-picker>
            </div>
        </div>
        <div class="global_popup_footer">
            <button @click.stop="confirm">{{$t('commonMsg.confirm')}}</button>
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
            dateTime: new Date(),
        }
    },
    methods: {
        confirm() {
            this.$emit('pushConfirm', this.dateTime)
            this.$store.commit('windowHandle')
        }
    }
}
</script>

<style lang="scss" scoped>
    .dateTimePicker-container{
        @include globalPopup(400px, 300px);
        .global_popup_body{
            .dateTimePicker-content{
                margin-top:40px;
                >.date-time-picker{
                    width:100%;
                }
            }
        }
        .global_popup_footer{
            padding-top:20px;
        }
    }
</style>
